module.exports = __webpack_public_path__ + "static/automated-supply-re-orders-eedb273a1ab7dc1fb0ace9b65d65ba10.png";